
  let devModeAlt;
  if(devMode !== undefined && devMode !== null){
    devModeAlt = devMode;
    devMode = false; // set devMode console output for this script only
  }
  

  let onpage_nav = document.querySelectorAll('[data-onpagenav]');

  // add on page nav to after first section
  let pagesections = document.querySelectorAll('main section');
  let navbar_items = '';
  const page_submenu_container = document.querySelector('#header-subnav');
  const header_submenu_el = document.querySelector('#header-subnav-elcon');
  let scrollPos = window.scrollY;
  (scrollPos > window.innerHeight) ? showPageSubMenu() : hidePageSubMenu();

  if(pagesections){
    if(devMode)console.info(`found ${pagesections.length} sections; building Page-Sub-Menu`);
    if(devMode)console.log(pagesections[0]); // insert subpagemenu after first section entry
    let navbar = '<div class="onpage-nav-container page-width" style="width:100vw;max-width:100vw;" id="onpageNav">'
    navbar +=     '<div class="subPageMenuContainer">';
    navbar +=       '<div class="subPageMenuFirstCol">';
    /* SubPageElements without Buy */
    navbar +=         '<div class="subPageMenuElementsContainer">'
    onpage_nav.forEach((el) => {
        if(devMode)console.log(`adding a-menu-tag for ${el.id}`);
        navbar_items += '<a class="onc-text-item onc-link-button" href="#' + el.id + '" data-targetid="' + el.id + '">' + el.dataset.value + '</a>';
    });
    navbar += navbar_items + '</div></div>';  // close spmElementsContainer + spmFirstCol
    // Buy Button
    if(devMode) console.info(`adding buy button to onpage menu`);
    navbar += '<div class="subPageMenuElementsContainer subPageMenuBuyButton"><a data-targetid="buy" class="onc-text-item onc-link-button buy-button-on-black">Buy</div>';
    navbar += '</div></div>';
    pagesections[0].insertAdjacentHTML('afterend',navbar);
    if(devMode) console.info(`Page-Sub-Menu hinzugefügt`);
  }

  if(header_submenu_el){
    header_submenu_el.innerHTML = navbar_items;
  }

  function showPageSubMenu(){
    //if(devMode)console.info(`show PageSubMenu because ${window.scrollY} ist größer als ${window.innerHeight}`);
    // Bedingung 1 : Header Element existiert
    if(!page_submenu_container) return false;
    // Bedingung 2: Screen Width ist größer als 750 Pixel
    const _width  = window.innerWidth || document.documentElement.clientWidth || 
    document.body.clientWidth;
    if(_width < 750) return false;

    if(page_submenu_container.classList.contains('subnavhide')){
      page_submenu_container.classList.remove('subnavhide');
    }
  }

  function hidePageSubMenu(){
    if(devMode)console.info(`show PageSubMenu because ${window.scrollY} ist kleiner als ${window.innerHeight}`);
    if(!page_submenu_container) return false;
    if(!page_submenu_container.classList.contains('subnavhide')){
      page_submenu_container.classList.add('subnavhide');
    }
  }

  // prepare sections for menu
  let targets = [];
  let onpage_sections = document.querySelectorAll('.onpage__menuitem');
  onpage_sections.forEach( (v,k)=>{
    let parentEl = v.parentElement;

    if(!parentEl.nextElementSibling) {
      if(devMode) console.info('undefined');
    } else {
      parentEl.nextElementSibling.classList.add("observe");
      parentEl.nextElementSibling.dataset.navid = v.id;
      targets.push(parentEl.nextElementSibling);
    };
  });
  
  
  // info ebene unten (only dev)
  let vis = (devMode) ? 'block' : 'none';
  let statediv = '<div class="observer__state" style="z-index:999; position: fixed; bottom: .5em;right: 1em; color: #555; font: 300 .9em/1.1 sans-serif; background: none; display:'+ vis +'"></div>';
  window.document.body.insertAdjacentHTML('afterbegin',statediv);
  


const subNav = document.querySelector("#onpageNav"),
navigationMainOriginalHeight = subNav.clientHeight,
scrollTresholdMenu = subNav.clientHeight;


let checkSubNav = false;
const state = document.querySelector('.observer__state')
const target = document.querySelector('#onpageNav')
if(devMode) console.log(target);

/*
const thresholdArray = steps => Array(steps + 1)
 .fill(0)
 .map((_, index) => index / steps || 0)

let previousY = 0
let previousRatio = 0

const handleIntersect = entries => {
  entries.forEach(entry => {
    const currentY = entry.boundingClientRect.y
    const currentRatio = entry.intersectionRatio
    const isIntersecting = entry.isIntersecting

    if(isIntersecting){
      checkSubNav = true;
    } else {
      checkSubNav = false;
    } 
    previousY = currentY
    previousRatio = currentRatio
  })
}

const observer = new IntersectionObserver(handleIntersect, {
  threshold: thresholdArray(20),
});

observer.observe(target);


const handleIntersect2 = entries => {
  entries.forEach(entry => {
    const currentY = entry.boundingClientRect.y
    const currentRatio = entry.intersectionRatio
    const isIntersecting = entry.isIntersecting
    if(isIntersecting){
      entry.style.borderColor = "red";
    }
  })
};

let options = {
  root: document.querySelector("main"),
  rootMargin: "0px",
  threshold: .5,
}
//const sectionObserver = new IntersectionObserver(function(entries, observer){
const sectionObserver = new IntersectionObserver(function(entries, options){
  entries.forEach(entry => {
    //entry.target.style.borderColor = "red";
    //document.querySelector('[data-targetid="'+ entry.target.dataset.navid +'"]').classList.add('sm_active');
    unhighlightMenuItem(document.querySelectorAll('.onc-link-button'));
    highlightMenuItem(document.querySelectorAll('[data-targetid="'+ entry.target.dataset.navid +'"]'));
  });
}, {
  thereshold: .5
});



// observe the submenu items
targets.forEach( target => {
  sectionObserver.observe(target);
});

function highlightMenuItem(els){
  if(!els) return false;
  els.forEach( el => {
    el.classList.add('mi_active');
  });
}
function unhighlightMenuItem(els){
  els.forEach( el => {
    el.classList.remove('mi_active');
  });
}

*/


// newIO
function handleIntersectionIO(entries, observer) {
  entries.forEach(entry => {
    //const targetId = entry.target.id;
    const targetId = entry.target.dataset.navid;
    if(devMode) console.log(`newIO`, entry.target);
    //const navItem = document.querySelector(`[data-targetid="${targetId}"]`); // here is more than one item = need array
    const navItemEls = document.querySelectorAll(`[data-targetid="${targetId}"]`); 

    
    if (entry.isIntersecting) {
      checkSubNav = true;
      navItemEls.forEach( el => {
        el.classList.add('mi_active');
        if(devMode) console.info(`add mi_active to ${el}`);
      });
      //navItem.classList.add('active');
    } else {
      checkSubNav = false;
      navItemEls.forEach( el => {
        el.classList.remove('mi_active');
        if(devMode) console.info(`remove mi_active from ${el}`);
      });
      //navItem.classList.remove('active');
    }
  });
}

const observerIO = new IntersectionObserver(handleIntersectionIO, { threshold: 0.5 });

//const sections = document.querySelectorAll('section');
//const navItems = document.querySelectorAll('nav li');
const navItems = document.querySelectorAll('.onc-link-button');
const sections = targets;

//console.info(`newIO`,targets);
//console.info(`navItemEls`, document.querySelectorAll(`[data-targetid]`));

sections.forEach(section => observerIO.observe(section));



/*navItems.forEach(navItem => {
  const targetId = navItem.dataset.targetid;
  const targetSection = document.querySelector(`[data-targetid="${targetId}"]`);

  navItem.addEventListener('click', () => {
    targetSection.scrollIntoView({ behavior: 'smooth' });
  });
});
*/




let lastKnownScrollPosition = 0;
let scrollDirection = false;

document.addEventListener('scroll', (e) => {
  scrollDirection = updateScrollDirection(window.scrollY);
  state.textContent = scrollDirection;
  lastKnownScrollPosition = window.scrollY;
  
  if(checkSubNav){
    // only run if subnav is in viewport (via observer)
    
    // get INFOS
    let headerHeight = document.querySelector('header').clientHeight;
    let stickyNavH = subNav.clientHeight; // stickyNav should have the same height than subNav on page
    let subNavY = document.querySelector('#onpageNav').offsetTop;
    let sy = Math.round(window.scrollY);

    // check if 
    if(scrollDirection == 'down'){
      if(sy > (subNavY)) showPageSubMenu();
    } else {
      if(Math.round(window.scrollY < (subNavY - (headerHeight) ) )) hidePageSubMenu();
    }
  }
});

function updateScrollDirection(_y){
  return (window.scrollY > lastKnownScrollPosition) ? "down" : "up";
}

/*
function showHeaderSubNav(){
  const _width  = window.innerWidth || document.documentElement.clientWidth || 
  document.body.clientWidth;
  if(_width > 750) page_submenu_container.style.display = 'block';
}
function hideHeaderSubNav(){
  page_submenu_container.style.display = 'none';
}
*/


const subMenuItems = document.querySelectorAll('.onc-link-button');
const sectionHeader = document.querySelector('#shopify-section-header');


subMenuItems.forEach( item => {
  item.addEventListener('click', function(event){
    event.preventDefault();
    const target = event.currentTarget.dataset.targetid;
    const targetElement = document.getElementById(target);
    if (!targetElement) return false;

    const doctop = window.scrollY;
    let scrollOffset = 0;

    const targetTop = targetElement.getBoundingClientRect().top + window.scrollY;
    if(doctop < targetTop) {
      // wir scrollen runter und müssen das Submenü berücksichtigen 
      if(page_submenu_container && window.innerWidth > 768){
        //if(devMode) console.log(`Höhe des SubMenüs ${page_submenu_container.offsetHeight}px`);
        scrollOffset = page_submenu_container.offsetHeight;
      } else {
        //console.info(`Kein Subnav container existiert, der Header ist ausgeblendet, es gibt kein scroll-offset der berücksichtigt werden müsste`);
        scrollOffset = 12;
      }
    } else {
      // wir scrollen hoch und der sticky header erscheint …
      if(devMode) console.log(`Höhe des Menüs ${sectionHeader.offsetHeight}px`);
      if(page_submenu_container) {
        scrollOffset = page_submenu_container.offsetHeight;
      }
      scrollOffset += sectionHeader.offsetHeight;
    }
   
    window.scrollTo({ top: Math.max(0, targetTop - scrollOffset), behavior: 'smooth' });
   
    return false;
  });
})




// return to old devMode state 

if(devMode !== undefined && devMode !== null){
  devMode = devModeAlt;
}
